export default {
  change_to_community: "community",
  entry: "entry",
  home: "Home",
  managers: "Managers",
  share: "share",
  wiki_post: "Posting",
  talks: "Community",
  wiki_notice: "WIKI Notice",
  search_within_the_wiki: "search...",
  calendar: "Calendar",
  prev_week: "Prev",
  next_week: "Next",
  prev_month: "Prev",
  next_month: "Next",
  weeks: {
    mon: "Mon",
    tue: "Tue",
    wed: "Wed",
    thu: "Thu",
    fri: "Fri",
    sat: "Sat",
    sun: "Sun"
  },
  time_left: "Time left:",
  time_left2: "<span>{day}days {hours}:{minutes}:{seconds}</span>",
  toggle_month: "Switch Mouths",
  toggle_week: "Switch Weeks",
  year: "-",
  mouth: "",
  calendar_toggle1: "toggle",
  calendar_toggle2: "toggle",
  calendar_end: "Has ended",
  official_notice: "notice",
  entry_update: "Updates",
  update: "update",
  community: "Community",
  community2: "Community",
  say_something: "Say something",
  send: "send",
  all: "All",
  posts: "Posts",
  strategy: "Strategy",
  question: "Question",
  notices: "Notices",
  entrys: "Entrys",
  views: "views",
  edit: "edit",
  history_record: "history record",
  favorite: "favorite",
  report: "report",
  created_on: "created on",
  nothing_more: "nothing more",
  comments: "Comments",
  comment: "Comment",
  follow: "Follow",
  followed: "Follow",
  fans: "Fans",
  favorites: "Favorites",
  back: "back",
  nosign: "no signature",
  check_in_details: "check in details",
  reply: "Reply",
  entrys2: "Entrys",
  hot_entry: "Hot entry",
  more: "more",
  post_details: "Post details",
  roll_back_to_the_version: "Roll back to this version",
  last_update: "Last update",
  cyct: "常用词条",
  gltj: "攻略推荐",
  modified_to_version: "modified to version: {version}",
  friendly_link: "Friendly link",
  notice_tags: {
    tag1: "",
    tag2: "",
    tag3: ""
  },
  login_to_post: "Login to post oh"
};
